import logger from './logger';

import api from './api';

import authHeader from './auth-header';
// Dans le fichier où vous avez besoin de l'adresse IP
import config from './config';
import AuthService from './auth.service';

const API_URL = `${config.serverIP}/${config.apiVersion}`;

class NotifService{

  getNbNotif() {

    const userId = AuthService.getUserId();

    const url = `${API_URL}/profils/users/${userId}/notifs/count`;
  
    const headers = authHeader();
  
    // Effectuer la requête GET avec Axios
    return api.get(url, { headers })
      .then(response => {
        logger.log('nb notification = ', response.data);
        // Traitez la réponse ici si besoin
        return response.data;
      })
      .catch(error => {
        // Gérer l'erreur ici
        logger.log('Erreur lors de la récupération du nombre de notifications:', error);
        throw error;
      });
  }
  

  getNotif() {
   
    const userId = AuthService.getUserId();

    const url = `${API_URL}/profils/users/${userId}/notifs`;
  
    const headers = authHeader();
  
    // Effectuer la requête GET avec Axios
    return api.get(url, { headers })
      .then(response => {
        logger.log('les notifications = ', response.data);
        // Traitez la réponse ici si nécessaire
        return response.data;
      })
      .catch(error => {
        // Gérer l'erreur ici
        logger.log('Erreur lors de la récupération des notifications:', error);
        throw error;
      });
  }
  


  async readNotif(notifId) {
    try {
     
      const userId = AuthService.getUserId();

      const url = `${API_URL}/profils/users/${userId}/notifs/${notifId}`;
  
      const headers = authHeader();  // Ajoutez vos headers d'authentification ici
      
      // Corps de la requête pour marquer la notification comme lue
      const requestBody = {
        status: 'read',  // Exemple de champ pour mettre à jour le statut
      };

      // Effectuer une requête PUT pour marquer la notification comme lue
      const updatedNotifFromBackend = await api.put(url, requestBody, { headers })
        .then(response => {
          return response.data;
        });
  
      logger.log('Notification mise à jour depuis le backend:', updatedNotifFromBackend);
      return updatedNotifFromBackend;
  
    } catch (error) {
      logger.log('Erreur lors de la mise à jour de la notification:', error);
      throw error;
    }
  }
  
    
}
// Créez une instance de NotifService
const notifServiceInstance = new NotifService();

// Exportez l'instance en tant qu'export par défaut
export default notifServiceInstance;